import axios from "axios";

// constants
import { BASE_URL } from "src/utils/constants";

// utils
import { getCurrentDate } from "src/utils/dateHelper";

export const getEventDetail = (_data) => {
  let now = getCurrentDate();

  let data = {
    userId: 0,
    eventId: _data?.eventId,
    accessToken: "",
    DateTimeNow: now.prettier.dateTimeNow,
    IsFromWeb: "1",
    timeId: _data?.timeId,
    latitude: _data.latitude,
    longitude: _data.longitude,
    // userId: _data?.userId || 0,
    // accessToken: _data?.accessToken || "",
    // EventLink: "",
  };

  const response = axios({
    method: "post",
    url: `${BASE_URL()}/NewEventDetail`,
    data: data,
  });

  return response;
};

export const postReview = (_data) => {
  const response = axios({
    method: "post",
    url: `${BASE_URL()}/Ratings`,
    data: _data,
  });

  return response;
};

export const getReviews = (_data) => {
  const response = axios({
    method: "post",
    url: `${BASE_URL()}/RatingReview`,
    data: _data,
  });

  return response;
};
